<template>
  <div class="bg">
    <div class="content">
      <top-header></top-header>
      <div class="content-box" :class="{ zh: isShowZh }">
        <div class="event-banner">
          <span class="back j-click-event-back" @click="backToHome">
            &lt;&lt;{{ letter.backToPay }}
          </span>
        </div>
        <div class="event-title" v-html="letter.shareEventTitle"></div>
        <div class="block-btn-list" @click="changeBlock">
          <div class="bag-btn j-click-award-bag" @click="showBagPopup">
            {{ letter.awardBag }}
          </div>
          <div class="rule-btn j-click-event-rule" @click="showRulePopup">
            {{ letter.shareRule }}
          </div>
          <a
            href="javascript:void(0);"
            class="block-left-btn j-click-event-tab1"
            :class="{ active: block == '1' }"
            data-block="1"
            >{{ letter.initiatorText }}</a
          >
          <a
            href="javascript:void(0);"
            class="block-right-btn j-click-event-tab2"
            :class="{ active: block == '0' }"
            data-block="0"
            >{{ letter.inviteeText }}</a
          >
        </div>
        <div class="main-block1" v-show="block == '1'">
          <div class="create-code-title">{{ letter.createCode }}</div>
          <div
            class="input1"
            @click="createInviteCode"
            :class="{ disable: isCreateCode }"
          >
            {{ isCreateCode ? invitationCode : letter.createCodeTip }}
          </div>
          <div
            class="copy-btn1 j-copy-btn1 j-click-event-copy"
            :class="{ disable: !isCreateCode, active: isActive1 }"
            @click="copy1"
            :data-clipboard-text="invitationCode"
          >
            {{ isActive1 ? copyText1 : letter.copyText }}
          </div>
          <div
            class="input2"
            @click="createInviteCode"
            :class="{ disable: isCreateCode }"
          >
            {{ isCreateCode ? invitationLink : letter.createLinkTip }}
          </div>
          <div
            class="copy-btn2 j-copy-btn2 j-click-event-copy"
            :class="{ disable: !isCreateCode, active: isActive2 }"
            @click="copy2"
            :data-clipboard-text="invitationLink"
          >
            {{ isActive2 ? copyText2 : letter.copyText }}
          </div>
          <div class="invite-award-title">{{ letter.inviteReward }}</div>
          <div class="invite-award-tip">{{ letter.inviteRewardTip }}</div>
          <div class="coupon-award1">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">{{ letter.overlay }}</div>
          </div>
          <div class="coupon-award2">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">{{ letter.overlay }}</div>
          </div>
          <div class="coupon-award3">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">{{ letter.overlay }}</div>
          </div>
          <div class="coupon-award-condition1">
            {{ letter.eventInviteSucc }}
          </div>
          <div class="coupon-award-condition2">{{ letter.rewardText2 }}</div>
          <div class="coupon-award-condition3">{{ letter.rewardText3 }}</div>
          <div class="overweight-award-title">
            {{ letter.overweightReward }}
          </div>
          <div class="overweight-award-tip">{{ letter.resetTip }}</div>
          <div class="coupon-award4">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">
              {{ isComplete1 ? letter.got : letter.get }}
            </div>
          </div>
          <div class="coupon-award5">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">
              {{ isComplete2 ? letter.got : letter.get }}
            </div>
          </div>
          <div class="coupon-award-condition4">{{ letter.rewardText4 }}</div>
          <div class="coupon-award-condition5">{{ letter.rewardText5 }}</div>
          <div class="share-code-title">{{ letter.shareCode }}</div>
          <div
            class="fb-share-btn j-click-facebook-share"
            @click="fbShare"
            v-show="isShowFB() && !isFbAndroid"
          >
            Facebook
          </div>
          <div
            class="tw-share-btn j-click-twitter-share"
            @click="twShare"
            v-show="curLang == 'ja-JP'"
          >
            Twitter
          </div>
          <div
            class="dc-share-btn j-click-discord-share"
            :class="{ moveCenter: isFbAndroid && isShowFB() }"
            @click="jumpLink"
            v-show="curLang != 'ko-KR'"
          >
            Discord
          </div>
          <!-- <div
            class="kakao-share-btn j-click-kakao-share"
            @click="kakaoShare"
            v-show="curLang == 'ko-KR'"
          >
            Kakao
          </div> -->
          <div
            class="naver-share-btn j-click-naver-share moveCenter"
            @click="naverShare"
            v-show="curLang == 'ko-KR'"
          >
            네이버 라운지
          </div>
          <div class="see-award-title">{{ letter.seeAward }}</div>
          <div class="see-award-tip" v-html="letter.seeAwardTip"></div>
          <div class="invitation-list-title">{{ letter.invitationList }}</div>
          <div class="refresh-btn j-click-event-refresh" @click="refresh">
            {{ letter.refresh }}
          </div>
          <div class="invited-total">
            {{ letter.invitedTotal.replace('${total}', inviteNum) }}
          </div>
          <div class="stored-total">
            {{ letter.storedTotal.replace('${total}', invitePayTotal) }}
          </div>
          <div class="list-sroll">
            <table class="invitation-list-table">
              <caption></caption>
              <thead>
                <tr>
                  <th class="table-people">{{ letter.invitedPeople }}</th>
                  <th class="table-time">{{ letter.invitedTime }}</th>
                  <th>9.99USD</th>
                  <th>49.99USD</th>
                  <th>99.99USD</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in inviteList">
                  <td class="table-people">{{ item.uid }}</td>
                  <td class="table-time">{{ item.time }}</td>
                  <td>{{ item.level1 ? letter.got : '/' }}</td>
                  <td>{{ item.level2 ? letter.got : '/' }}</td>
                  <td>{{ item.level3 ? letter.got : '/' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="main-block2" v-show="block == '0'">
          <div class="input-code-title">{{ letter.inputCode }}</div>
          <input
            class="input3 placeholder"
            type="text"
            v-model="inviteCode"
            :placeholder="letter.inputCode"
            :contenteditable="!isBindCode"
          />
          <div
            class="bind-code-btn j-click-event-bind"
            :class="{ disable: isBindCode }"
            @click="handleBind"
          >
            {{ isBindCode ? letter.bindSucc : letter.bindCode }}
          </div>
          <div class="bind-code-tip" v-show="isShowBindTip">{{ bindTip }}</div>
          <div class="personal-award-title">{{ letter.personalReward }}</div>
          <div class="coupon-award6">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">
              {{ myPayInfo[1] ? letter.got : letter.get }}
            </div>
          </div>
          <div class="coupon-award7">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">
              {{ myPayInfo[2] ? letter.got : letter.get }}
            </div>
          </div>
          <div class="coupon-award8">
            <div class="coupon-award-text1">{{ letter.couponText }}</div>
            <div class="coupon-award-text2">
              {{ myPayInfo[3] ? letter.got : letter.get }}
            </div>
          </div>
          <div class="coupon-award-condition6">
            {{ letter.eventSuccBind }}
          </div>
          <div class="coupon-award-condition7">
            {{ letter.personalRewardText2 }}
          </div>
          <div class="coupon-award-condition8">
            {{ letter.personalRewardText3 }}
          </div>
        </div>
      </div>
    </div>
    <page-footer v-show="true"></page-footer>
    <transition name="fade" mode="out-in">
      <event-tip-popup
        v-if="isShowEventTipPopup"
        popupType=""
        :eventTipText="popupTip"
        @closeTipPopup="hideEventTipPopup"
      >
      </event-tip-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <event-bag-popup
        v-if="isShowBagPopup"
        popupType=""
        @closeBagPopup="hideBagPopup"
      >
      </event-bag-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <event-rule-popup
        v-if="isShowRulePopup"
        popupType=""
        @closeRulePopup="hideRulePopup"
      >
      </event-rule-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="isShowGameItemUseBtn"
        @closeCouponPopup="hideGameCouponPopup"
      >
      </coupon-list-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <event-bind-popup
        v-if="showBindPopup"
        :inviteCode="inviteCode"
        @closePopup="showBindPopup = false"
        @sureBind="bindInviteCode"
      >
      </event-bind-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <event-bind-succ-popup
        v-if="showBindSuccPopup"
        @showGameCoupon="showGameCoupon"
        @closePopup="showBindSuccPopup = false"
      >
      </event-bind-succ-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <coupon-vip-popup
        v-if="isShowVipCouponPopup"
        :showItemUseBtn="false"
        @closeCouponPopup="hideVipCouponPopup"
        :couponList="vipCouponList"
      ></coupon-vip-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
    <theme-config v-if="showThemeConfig"></theme-config>
  </div>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import TopHeader from '@components/officialStore/TopHeader.vue';
import PageFooter from '@components/officialStore/PageFooter.vue';
import EventTipPopup from '@components/officialStore/event/EventTipPopup.vue';
import EventBagPopup from '@components/officialStore/event/EventBagPopup.vue';
import EventRulePopup from '@components/officialStore/event/EventRulePopup.vue';
import CouponListPopup from '@components/officialStore/coupon/CouponListPopup.vue';
import event from '@mixins/officialStore/event';
import coupon from '@mixins/officialStore/coupon';
import languages from '@store/languages';
import Clipboard from 'clipboard';
import EventBindPopup from '@components/officialStore/event/EventBindPopup.vue';
import EventBindSuccPopup from '@components/officialStore/event/EventBindSuccPopup.vue';
import CouponVipPopup from '@components/officialStore/coupon/CouponVipPopup.vue';
import Loading from '@components/officialStore/Loading.vue';
import { injectScript } from '@utiles/officialStore/index';
import {
  BIND_CODE,
  CREATE_CODE,
  LOAD_EVENT_BASIC,
  GET_AWARD,
  GET_AWARD_LOG,
  EVENT_IS_LOGIN
} from '@store/officialStore/event';
import { mapActions } from 'vuex';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
const hostname = window.location.hostname;
let arr = hostname.split('.');
export default {
  name: 'SharePage',
  mixins: [event, coupon],
  data() {
    return {
      popupTip: '',
      bindTip: '',
      copyText1: this.$store.state.letter.copyText,
      copyText2: this.$store.state.letter.copyText,
      inviteCode: this.$store.state.bindInvitationCode,
      isActive1: false,
      isActive2: false,
      isShowBindTip: false,
      isFbAndroid: false,
      isShowZh: false,
      showBindPopup: false,
      showBindSuccPopup: false
    };
  },
  beforeCreate() {
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/zh_TW/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    window.fbAsyncInit = function () {
      FB.init({
        appId: 2303380839957579,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.3',
        status: true
      });
      FB.AppEvents.logPageView();
    };
    this.$store
      .dispatch(EVENT_IS_LOGIN)
      .then(async res => {
        window.activityDataLayer.push({
          eventName: 'login',
          aid: 'ztmslgpay',
          uid: res.data.UID,
          loginAccount: res.data.LOGIN_ACCOUNT,
          gameId: 191,
          ...getGlobalGetLinkParams({ acitivtyId: '953' })
        });
      })
      .catch();
  },
  created() {
    let lang = languages.getLanguage();
    lang = lang.toLowerCase();
    if (lang.includes('zh')) {
      this.isShowZh = true;
    }
    if (this.isFBAndroid()) {
      this.isFbAndroid = true;
    }
    // 晓亚：暂不接入Kakao分享，目前暂无KAKAO_KEY
    // if (lang == 'ko-kr') {
    //   injectScript('https://developers.kakao.com/sdk/js/kakao.js', () => {
    //     const KAKAO_KEY = '';
    //     window.Kakao.init(KAKAO_KEY);
    //   });
    // }
    this.loadVipCouponInfo();
    this.$store
      .dispatch(LOAD_EVENT_BASIC)
      .then(async res => {
        if (res.data.isBind) {
          this.inviteCode = res.data.bindCode;
        }
        if (!this.isBindCode && globalConfig.getHrefParam('shareCode')) {
          this.inviteCode = globalConfig.getHrefParam('shareCode');
          // this.bindInviteCode();
          this.showBindPopup = true;
        }
        if (res.data.needAward) {
          this.$store
            .dispatch(GET_AWARD)
            .then(async _res => {
              //弹窗
              setTimeout(() => {
                this.loadGameCouponList();
                this.showGameCouponPopup();
              }, 4000);
            })
            .catch();
        }
      })
      .catch();
  },
  computed: {
    showThemeConfig() {
      return this.$store.state.showThemeConfig;
    },
    curLang() {
      return this.$store.state.lang;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    curLang(newV, _oldV) {
      this.isShowZh = newV.includes('zh') ? true : false;
    }
  },
  methods: {
    ...mapActions({
      bindCode: BIND_CODE,
      createCode: CREATE_CODE,
      loadEventBasic: LOAD_EVENT_BASIC,
      getAward: GET_AWARD,
      getAwardLog: GET_AWARD_LOG
    }),
    isFBAndroid() {
      return (
        /FB/.test(navigator.userAgent) && /Android/.test(navigator.userAgent)
      );
    },
    backToHome() {
      const sourceParams = {
        cid: globalConfig.getHrefParam('cid'),
        fromStoreCid: globalConfig.getHrefParam('fromStoreCid'),
        scid: globalConfig.getHrefParam('scid'),
        fromStoreScid: globalConfig.getHrefParam('fromStoreScid'),
        language:
          globalConfig.getHrefParam('language') || this.curLang || 'en-US'
      };
      const isFromStore =
        sourceParams.fromStoreCid || sourceParams.fromStoreScid;
      const preUrl =
        process.env.NODE_ENV === 'production'
          ? `pay.${globalConfig.getMainHost()}/platform`
          : `gabres-test.${globalConfig.getMainHost()}`;
      this.eventDataReport('返回储值');
      window.location.href = window.globalGetGotoLink({
        link: `https://${preUrl}/officialStore.html?gameId=${
          this.$store.state.gameId
        }&cid=${
          isFromStore ? sourceParams.fromStoreCid : sourceParams.cid
        }&scid=${
          isFromStore ? sourceParams.fromStoreScid : sourceParams.scid
        }&languages=${sourceParams.language}#/`
      });
    },
    jumpLink() {
      this.eventDataReport('discord');
      window.open('https://discord.com/invite/puzzlesandsurvival', '_blank');
    },
    changeBlock({ target }) {
      const eleBlock = target.dataset.block;
      if (eleBlock == '1' || eleBlock == '0') {
        this.setBlock(eleBlock);
      }
      if (eleBlock == '1') {
        this.eventDataReport('我是发起人');
      } else {
        this.eventDataReport('我是受邀人');
      }
    },
    isShowFB() {
      const filterArr = ['ja-JP', 'ko-KR'];
      return !filterArr.includes(languages.getLanguage());
    },
    copy1() {
      this.eventDataReport('复制');
      const clipboard = new Clipboard('.j-copy-btn1');
      clipboard.on('success', e => {
        this.popupTip = this.letter.copySucc;
        this.showEventTipPopup();
        this.isActive1 = true;
        let suplusSeconds = 4;
        const gameTimer = setInterval(() => {
          suplusSeconds--;
          if (suplusSeconds == 0) {
            this.isActive1 = false;
            clearInterval(gameTimer);
            this.copyText1 = this.$store.state.letter.copyText;
            return;
          }
          this.copyText1 =
            this.$store.state.letter.copyText + '(' + suplusSeconds + 's)';
        }, 1000);
        e.clearSelection();
      });
      clipboard.on('error', _e => {
        this.popupTip = this.letter.errorTip;
        this.showEventTipPopup();
      });
    },
    copy2() {
      this.eventDataReport('复制');
      const clipboard = new Clipboard('.j-copy-btn2');
      clipboard.on('success', e => {
        this.popupTip = this.letter.copySucc;
        this.showEventTipPopup();
        this.isActive2 = true;
        let suplusSeconds = 4;
        const gameTimer = setInterval(() => {
          suplusSeconds--;
          if (suplusSeconds == 0) {
            this.isActive2 = false;
            clearInterval(gameTimer);
            this.copyText2 = this.$store.state.letter.copyText;
            return;
          }
          this.copyText2 =
            this.$store.state.letter.copyText + '(' + suplusSeconds + 's)';
        }, 1000);
        e.clearSelection();
      });
      clipboard.on('error', _e => {
        this.popupTip = this.letter.errorTip;
        this.showEventTipPopup();
      });
    },
    createInviteCode() {
      this.$store
        .dispatch(CREATE_CODE)
        .then()
        .catch(err => {
          if (+err.code === -20001) {
            window.location.href = `https://pay.${
              arr[1]
            }.com/platform/login.html?gameId=191&forward=${encodeURIComponent(
              window.location.href
            )}`;
            return;
          }
          if (+err.code === -20003) {
            this.popupTip = this.letter.codeTip6;
            this.showEventTipPopup();
          }
        });
    },
    bindInviteCode() {
      this.showBindPopup = false;
      this.eventDataReport('绑定邀请码');
      let code = this.inviteCode;
      this.$store
        .dispatch(BIND_CODE, {
          bind_code: code
        })
        .then(() => {
          this.showBindSuccPopup = true;
        })
        .catch(err => {
          if (+err.code === -20001) {
            window.location.href = `https://pay.${
              arr[1]
            }.com/platform/login.html?gameId=191&forward=${encodeURIComponent(
              window.location.href
            )}`;
            return;
          }
          if (+err.code === -20002) {
            this.popupTip = this.letter.codeTip4;
            this.showEventTipPopup();
            return;
          }
          if (+err.code === -20005) {
            this.popupTip = this.letter.codeTip1;
            this.showEventTipPopup();
            return;
          }
          if (+err.code === -20006) {
            this.popupTip = this.letter.codeTip5;
            this.showEventTipPopup();
            return;
          }
          if (+err.code === -20008) {
            this.popupTip = this.letter.codeTip7;
            this.showEventTipPopup();
            return;
          }
          this.popupTip = this.letter.errorTip;
          this.showEventTipPopup();
        });
    },
    twShare() {
      this.eventDataReport('twitter');
      const title = this.letter.eventShareText1;
      let link = this.isCreateCode
        ? 'https://pay.' +
          arr[1] +
          '.com/platform/officialStore.html?gameId=191&cid=share&scid=twitter&shareCode=' +
          this.invitationCode +
          '#/share_event'
        : 'https://pay.' +
          arr[1] +
          '.com/platform/officialStore.html?gameId=191&cid=share&scid=twitter#/share_event';
      let url =
        '//twitter.com/intent/tweet?text=' +
        encodeURIComponent(title) +
        ' ' +
        encodeURIComponent(link);
      window.open(url);
    },
    kakaoShare() {
      this.eventDataReport('kakao');
      const title = this.letter.eventShareText1;
      let shareUrl = this.isCreateCode
        ? `https://pay.${arr[1]}.com/platform/officialStore.html?gameId=191&cid=share&scid=fb&shareCode=${this.invitationCode}#/share_event`
        : `https://pay.${arr[1]}.com/platform/officialStore.html?gameId=191&cid=share&scid=fb#/share_event`;
      window.Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: title,
          imageUrl: 'https://abres.octlib.com/platform/img/fb-share-kr.jpg',
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl
          }
        },
        installTalk: true // 如果未安装 KakaoTalk，请前往市场中的 KakaoTalk 安装页面。 默认为false
      });
    },
    naverShare() {
      this.eventDataReport('naver');
      window.open('https://game.naver.com/lounge/puzzle_of_Z/board');
    },
    async fbShare() {
      this.eventDataReport('facebook');
      const getLoginStatus = isClean => {
        return new Promise(resolve => {
          FB.getLoginStatus(response => {
            resolve(response.status === 'connected');
          }, isClean);
        });
      };

      const fbLogin = () => {
        return new Promise(resolve => {
          FB.login(function (response) {
            resolve(response.status === 'connected');
          });
        });
      };

      const excShare = info => {
        return new Promise(resolve => {
          FB.ui(info, function (res) {
            resolve(res && !res.error_message);
          });
        });
      };
      let lang = languages.getLanguage();
      lang = lang.toLowerCase();
      const message = this.letter.eventShareText2;
      const title = this.letter.eventShareText1;
      let picUrl = ``;
      if (lang.includes('zh-cn')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-cn.jpg`;
      } else if (lang.includes('zh-tw')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-tw.jpg`;
      } else if (lang.includes('ja')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-ja.jpg`;
      } else if (lang.includes('kr')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-kr.jpg`;
      } else if (lang.includes('ru')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-ru.jpg`;
      } else if (lang.includes('de')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-de.jpg`;
      } else if (lang.includes('fr')) {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-fr.jpg`;
      } else {
        picUrl = `https://abres.octlib.com/platform/img/fb-share-en.jpg`;
      }
      const shareInfo = {
        title: encodeURIComponent(title),
        message: encodeURIComponent(message),
        id: 2303380839957579,
        img: encodeURIComponent(picUrl)
      };
      let shareUrl = this.isCreateCode
        ? `https://pay.${arr[1]}.com/platform/officialStore.html?gameId=191&cid=share&scid=fb&shareCode=${this.invitationCode}#/share_event`
        : `https://pay.${arr[1]}.com/platform/officialStore.html?gameId=191&cid=share&scid=fb#/share_event`;
      let url = encodeURIComponent(shareUrl);
      let data = {
        method: 'share',
        href:
          'https://gactivityapi.' +
          arr[1] +
          '.com/fbShareCustomize/customizeShare/message/' +
          shareInfo.message +
          '/app_id/' +
          shareInfo.id +
          '/share_title/' +
          shareInfo.title +
          '/redict_url/' +
          url +
          '/pic_url/' +
          shareInfo.img,
        display: 'popup'
      };
      let checkRes = await getLoginStatus();
      !checkRes && (await fbLogin());
      await excShare(data);
    },
    refresh() {
      this.eventDataReport('刷新');
      this.$store
        .dispatch(LOAD_EVENT_BASIC)
        .then(async res => {
          if (res.data.isBind) {
            this.inviteCode = res.data.bindCode;
          }
          if (res.data.needAward) {
            this.$store
              .dispatch(GET_AWARD)
              .then(async _res => {
                //弹窗
                this.loadGameCouponList();
                this.showGameCouponPopup();
              })
              .catch();
          }
        })
        .catch(err => {
          if (+err.code === -20001) {
            window.location.href = `https://pay.${
              arr[1]
            }.com/platform/login.html?gameId=191&forward=${encodeURIComponent(
              window.location.href
            )}`;
          }
        });
    },
    eventDataReport(type) {
      window.activityDataLayer.push({
        eventName: 'click_button',
        eventType: type,
        aid: 'ztmslgpay',
        gameId: 191,
        ...getGlobalGetLinkParams({ acitivtyId: '953' })
      });
    },
    handleBind() {
      if (this.inviteCode) {
        this.showBindPopup = true;
        return;
      }
      this.popupTip = this.letter.inputCode;
      this.showEventTipPopup();
    },
    showGameCoupon() {
      this.loadGameCouponList();
      this.showGameCouponPopup();
    }
  },
  components: {
    TopHeader,
    PageFooter,
    EventTipPopup,
    EventBagPopup,
    EventRulePopup,
    CouponListPopup,
    EventBindPopup,
    EventBindSuccPopup,
    CouponVipPopup,
    Loading,
    ThemeConfig: () => import('@components/officialStore/ThemeConfig.vue')
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';

.bg {
  display: block;
  float: left;
  position: relative;
  width: 100%;
  height: 2800px;
  min-height: 100%;
  background-color: var(--event-bg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  text-align: center;
}

.content {
  position: relative;
  margin: 40px 0 200px;
}

.content-box {
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1200px;
  font-size: 0;
  color: var(--vip-content);

  .back {
    position: absolute;
    top: 120px;
    left: 20px;
    cursor: pointer;
    font-size: 20px;
    text-align: center;
    width: 138px;
    height: 26px;
    line-height: 26px;
    @psetbg ('share-back-home.png', false);
  }

  .event-banner {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 750px;
    background-size: contain;
    @psetbg ('share-banner.png', false);
  }

  .event-title {
    position: absolute;
    top: 400px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 700;
    font-size: 38px;
    color: var(--vip-title);
    line-height: 43px;
    width: 651px;
    height: 64px;
    @psetbg ('share-title-bg.png', false);
  }

  .block-btn-list {
    position: absolute;
    top: 440px;
    left: 50%;
    transform: translateX(-50%);
    width: 625px;
    height: 174px;

    .bag-btn {
      position: absolute;
      top: 50px;
      left: 100px;
      font-size: 24px;
      color: var(--event-btn);
      text-decoration: underline;
    }

    .rule-btn {
      position: absolute;
      top: 50px;
      right: 110px;
      font-size: 24px;
      color: var(--event-btn);
      text-decoration: underline;
    }

    .block-left-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 281px;
      height: 74px;
      font-size: 28px;
      color: var(--event-tip);
      line-height: 74px;
      @psetbg ('share-tab-normal.png', false);

      &.active {
        background: url('../../assets/image/officialStore/ztmslg/share-tab-active.png')
          no-repeat;
      }
    }

    .block-right-btn {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 282px;
      height: 74px;
      font-size: 28px;
      color: var(--event-tip);
      line-height: 74px;
      @psetbg ('share-tab-normal.png', false);

      &.active {
        background: url('../../assets/image/officialStore/ztmslg/share-tab-active.png')
          no-repeat;
      }
    }
  }

  .main-block1 {
    position: absolute;
    top: 640px;
    left: 50%;
    transform: translateX(-50%);
    width: 660px;
    height: 1945px;
    background-color: var(--event-block);
    border: 2px solid var(--event-block-border);

    .create-code-title {
      margin-top: 20px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
      @psetbg ('step1.png', false);
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .input1 {
      position: absolute;
      left: 40px;
      top: 110px;
      font-size: 18px;
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 365px;
      height: 55px;
      background-color: var(--event-block);
      border: 1px solid var(--event-block-border);
      color: var(--event-title);

      &.disable {
        pointer-events: none;
      }
    }

    .input2 {
      position: absolute;
      left: 40px;
      top: 190px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      width: 365px;
      height: 55px;
      background-color: var(--event-block);
      border: 1px solid var(--event-block-border);
      color: var(--event-title);

      &.disable {
        display: unset;
        align-items: unset;
        justify-content: unset;
        flex-direction: unset;
        pointer-events: none;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        text-align: left;
        padding-left: 5px;
        line-height: 55px;
      }
    }

    .copy-btn1 {
      position: absolute;
      right: 40px;
      top: 110px;
      font-size: 20px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-copy-active.png', false);

      &.active {
        pointer-events: none;
        background: url('../../assets/image/officialStore/ztmslg/share-copy-normal.png')
          no-repeat;
      }

      &.disable {
        pointer-events: none;
      }
    }

    .copy-btn2 {
      position: absolute;
      right: 40px;
      top: 190px;
      font-size: 20px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-copy-active.png', false);

      &.active {
        pointer-events: none;
        background: url('../../assets/image/officialStore/ztmslg/share-copy-normal.png')
          no-repeat;
      }

      &.disable {
        pointer-events: none;
      }
    }

    .share-code-title {
      position: absolute;
      width: 100%;
      top: 1085px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
      @psetbg ('step2.png', false);
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .fb-share-btn {
      position: absolute;
      left: 80px;
      top: 1175px;
      font-size: 24px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-btn-left.png', false);
    }

    .tw-share-btn {
      position: absolute;
      left: 100px;
      top: 1175px;
      font-size: 24px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-btn-left.png', false);
    }

    .kakao-share-btn {
      position: absolute;
      left: 100px;
      top: 1175px;
      font-size: 24px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-btn-left.png', false);
    }

    .naver-share-btn {
      position: absolute;
      right: 100px;
      top: 1175px;
      font-size: 24px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-btn-right.png', false);
      &.moveCenter {
        right: 50%;
        transform: translateX(50%);
      }
    }

    .dc-share-btn {
      position: absolute;
      right: 100px;
      top: 1175px;
      font-size: 24px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-btn-right.png', false);
      &.moveCenter {
        right: 50%;
        transform: translateX(50%);
      }
    }

    .see-award-title {
      position: absolute;
      width: 100%;
      top: 1285px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
      @psetbg ('step3.png', false);
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .see-award-tip {
      position: absolute;
      width: 100%;
      top: 1355px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);

      ::v-deep .see-light {
        color: var(--event-see) !important;
      }
    }

    .invite-award-title {
      position: absolute;
      width: 100%;
      top: 290px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
    }

    .invite-award-tip {
      position: absolute;
      width: 100%;
      top: 350px;
      text-align: center;
      font-size: 18px;
      color: var(--event-title);
    }

    .coupon-award1 {
      position: absolute;
      left: 60px;
      top: 370px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon1.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-one);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award2 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 370px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon2.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-two);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award3 {
      position: absolute;
      right: 60px;
      top: 370px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon3.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-three);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award-condition1 {
      position: absolute;
      left: 90px;
      width: 135px;
      top: 555px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .coupon-award-condition2 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 135px;
      top: 555px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .coupon-award-condition3 {
      position: absolute;
      right: 95px;
      width: 135px;
      top: 555px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .overweight-award-title {
      position: absolute;
      width: 100%;
      top: 670px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
    }

    .overweight-award-tip {
      position: absolute;
      width: 100%;
      top: 730px;
      text-align: center;
      font-size: 18px;
      color: var(--event-title);
    }

    .coupon-award4 {
      position: absolute;
      left: 40px;
      top: 730px;
      width: 289px;
      height: 297px;
      @psetbg ('share-coupon4.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 35px;
        top: 142px;
        text-align: center;
        font-size: 16px;
        line-height: 35px;
        color: var(--event-coupon-four);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 35px;
        top: 177px;
        text-align: center;
        font-size: 16px;
        line-height: 35px;
      }
    }

    .coupon-award5 {
      position: absolute;
      right: 40px;
      top: 730px;
      width: 289px;
      height: 297px;
      @psetbg ('share-coupon5.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 35px;
        top: 142px;
        text-align: center;
        font-size: 16px;
        line-height: 35px;
        color: var(--event-coupon-five);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 35px;
        top: 177px;
        text-align: center;
        font-size: 16px;
        line-height: 35px;
      }
    }

    .coupon-award-condition4 {
      position: absolute;
      left: 30px;
      width: 290px;
      top: 990px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .coupon-award-condition5 {
      position: absolute;
      right: 30px;
      width: 290px;
      top: 990px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .invitation-list-title {
      position: absolute;
      width: 100%;
      top: 1450px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
    }

    .refresh-btn {
      position: absolute;
      width: 100%;
      top: 1510px;
      text-align: center;
      font-size: 22px;
      color: var(--event-refresh);
      text-decoration: underline;
      cursor: pointer;
    }

    .invited-total {
      position: absolute;
      width: 100%;
      top: 1550px;
      text-align: center;
      font-size: 25px;
      color: var(--event-title);
    }

    .stored-total {
      position: absolute;
      width: 100%;
      top: 1590px;
      text-align: center;
      font-size: 25px;
      color: var(--event-title);
    }

    .list-sroll {
      position: absolute;
      top: 1640px;
      left: 50%;
      transform: translateX(-50%);
      width: 630px;
      height: 286px;
    }

    ::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
      background: #ffffff;
      border-radius: 4px;
    }

    .invitation-list-table {
      border-collapse: unset;
      border-spacing: unset;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 286px;
      border: 1px solid var(--event-block-border);

      thead {
        background-color: var(--event-block-border);
        color: var(--event-title);
      }

      tbody {
        display: block;
        width: 100%;
        height: 240px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }

      tr {
        box-sizing: border-box;
        table-layout: fixed;
        display: table;
        width: 100%;
      }

      td {
        border: 1px solid var(--event-block-border);
        height: 46px;
        line-height: 46px;
        text-align: center;
        font-size: 18px;
        color: var(--event-title);
        white-space: pre-wrap;
      }

      th {
        height: 46px;
        text-align: center;
        font-size: 20px;
        color: var(--event-title);
        white-space: pre-wrap;
        border: none;
      }

      .table-people {
        width: 145px;
      }

      .table-time {
        width: 145px;
      }
    }
  }

  .main-block2 {
    position: absolute;
    top: 640px;
    left: 50%;
    transform: translateX(-50%);
    width: 660px;
    height: 680px;
    background-color: var(--event-block);
    border: 1px solid var(--event-block-border);

    .input-code-title {
      margin-top: 30px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
      @psetbg ('step1.png', false);
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .input3 {
      position: absolute;
      left: 35px;
      top: 120px;
      font-size: 20px;
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 370px;
      height: 55px;
      background-color: var(--event-block);
      border: 1px solid var(--event-block-border);
      color: var(--event-title);

      &:empty::before {
        color: var(--event-block-border);
        content: attr(placeholder);
      }

      &:focus::before {
        content: '';
      }
    }

    .bind-code-btn {
      position: absolute;
      right: 40px;
      top: 120px;
      font-size: 20px;
      line-height: 60px;
      width: 204px;
      height: 60px;
      @psetbg ('share-copy-active.png', false);

      &.disable {
        background: url('../../assets/image/officialStore/ztmslg/share-copy-normal.png')
          no-repeat;
        pointer-events: none;
      }
    }

    .bind-code-tip {
      position: absolute;
      left: 35px;
      top: 200px;
      font-size: 20px;
      color: var(--event-title);
    }

    .personal-award-title {
      position: absolute;
      width: 100%;
      top: 250px;
      text-align: center;
      font-weight: 600;
      font-size: 35px;
      color: var(--event-title);
      @psetbg ('step2.png', false);
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .coupon-award6 {
      position: absolute;
      left: 60px;
      top: 340px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon1.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-one);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award7 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 340px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon2.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-two);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award8 {
      position: absolute;
      right: 60px;
      top: 340px;
      width: 202px;
      height: 208px;
      @psetbg ('share-coupon3.png', false);

      .coupon-award-text1 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 95px;
        text-align: center;
        font-size: 14px;
        line-height: 25px;
        color: var(--event-coupon-three);
      }

      .coupon-award-text2 {
        position: absolute;
        width: 100%;
        height: 25px;
        top: 120px;
        text-align: center;
        font-size: 12px;
        line-height: 25px;
      }
    }

    .coupon-award-condition6 {
      position: absolute;
      left: 90px;
      width: 135px;
      top: 540px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .coupon-award-condition7 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 135px;
      top: 540px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }

    .coupon-award-condition8 {
      position: absolute;
      right: 95px;
      width: 135px;
      top: 540px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      line-height: 24px;
    }
  }
}
.zh {
  .event-title {
    font-size: 48px;
  }
  .main-block1 {
    .create-code-title {
      font-size: 36px;
    }
    .share-code-title {
      font-size: 36px;
    }
    .see-award-title {
      font-size: 36px;
    }
    .invite-award-title {
      font-size: 36px;
    }
    .overweight-award-title {
      font-size: 36px;
    }
    .invitation-list-title {
      font-size: 36px;
    }
  }
  .main-block2 {
    .input-code-title {
      font-size: 36px;
    }
    .personal-award-title {
      font-size: 36px;
    }
  }
}
</style>
